// Generated from ESF schema: build
// Do not edit manually!
/** Build profile (optimization level) */
export var BuildProfile;
(function (BuildProfile) {
    BuildProfile["Debug"] = "debug";
    BuildProfile["Release"] = "release";
    BuildProfile["ReleaseLto"] = "release-lto";
})(BuildProfile || (BuildProfile = {}));
/** Supported build targets */
export var BuildTarget;
(function (BuildTarget) {
    BuildTarget["Wasm32UnknownUnknown"] = "wasm32-unknown-unknown";
    BuildTarget["X8664UnknownLinuxGnu"] = "x86_64-unknown-linux-gnu";
    BuildTarget["Aarch64UnknownLinuxGnu"] = "aarch64-unknown-linux-gnu";
    BuildTarget["Aarch64AppleDarwin"] = "aarch64-apple-darwin";
    BuildTarget["X8664AppleDarwin"] = "x86_64-apple-darwin";
})(BuildTarget || (BuildTarget = {}));
/** Components that can be built/released */
export var Component;
(function (Component) {
    Component["Console"] = "console";
    Component["EdgeProxy"] = "edge-proxy";
    Component["Ops"] = "ops";
    Component["Scatter"] = "scatter";
    Component["Kernel"] = "kernel";
    Component["Spark"] = "spark";
    Component["Identity"] = "identity";
})(Component || (Component = {}));
/** Deployment environments */
export var Environment;
(function (Environment) {
    Environment["AlphaDevnet"] = "alpha-devnet";
    Environment["BetaDevnet"] = "beta-devnet";
    Environment["Devnet"] = "devnet";
    Environment["Testnet"] = "testnet";
    Environment["Mainnet"] = "mainnet";
})(Environment || (Environment = {}));
/** Semantic version bump type */
export var VersionBump;
(function (VersionBump) {
    VersionBump["Major"] = "major";
    VersionBump["Minor"] = "minor";
    VersionBump["Patch"] = "patch";
})(VersionBump || (VersionBump = {}));
//# sourceMappingURL=build.js.map